type Props = {
	iconChildren: React.ReactNode;
	ctaChildren: React.ReactNode;
};

export const ErrorBoundaryLayout = ({ iconChildren, ctaChildren }: Props) => {
	return (
		<div className="mx-auto grid h-screen w-full place-content-center place-items-center px-4 laptop:max-w-3xl laptop:px-0">
			<div className="flex flex-col items-center gap-y-14 laptop:flex-row laptop:gap-x-20">
				{iconChildren}
				{ctaChildren}
			</div>
		</div>
	);
};

ErrorBoundaryLayout.displayName = "ErrorBoundaryLayout";
